const getConfig = () => {
  let apiUrl = process.env.REACT_APP_API_URL || process.env.API_URL;
  
  if (window.env && window.env.API_URL) {
    apiUrl = window.env.API_URL;
  }
  
  if (!apiUrl) {
    apiUrl = '/api';
  } else if (!apiUrl.endsWith('/api') && !apiUrl.startsWith('/')) {
    apiUrl = apiUrl.endsWith('/') ? `${apiUrl}api` : `${apiUrl}/api`;
  }

  const config = {
    API_URL: apiUrl,
    PORTAL_URL: process.env.REACT_APP_PORTAL_URL || process.env.PORTAL_URL || 'https://portal.garagedesk.net',
    CUSTOMER_PORTAL_URL: process.env.REACT_APP_CUSTOMER_PORTAL_URL || process.env.CUSTOMER_PORTAL_URL || 'https://customer.garagedesk.net',
    ADMIN_DASHBOARD_URL: process.env.REACT_APP_ADMIN_DASHBOARD_URL || process.env.ADMIN_DASHBOARD_URL || 'https://admin.garagedesk.net'
  };

  if (window.env) {
    if (window.env.PORTAL_URL) config.PORTAL_URL = window.env.PORTAL_URL;
    if (window.env.CUSTOMER_PORTAL_URL) config.CUSTOMER_PORTAL_URL = window.env.CUSTOMER_PORTAL_URL;
    if (window.env.ADMIN_DASHBOARD_URL) config.ADMIN_DASHBOARD_URL = window.env.ADMIN_DASHBOARD_URL;
  }

  return config;
};

export const config = getConfig();

